<!--
 * @Description: 项目背景介绍
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <div
          class="xrk-card"
          @click="onChange(item.value)"
          style="width: 420px; height: 600px"
        >
          <div
            :style="{
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            }"
          >
            <component
              v-if="titleCmpt"
              :is="titleCmpt"
              style="
                width: 1200px;
                transform: scale(0.33);
                transform-origin: 0 center;
              "
              v-bind="{
                innerText: '项目背景介绍',
                enInnerText: 'Project Background Introduction'
              }"
            />

            <div
              :style="{
                fontSize: '14px',
                position: 'relative',
                height: '120px',
                padding: '28px 24px 18px 32px',
                marginTop: '15px'
              }"
            >
              <div v-html="getBorderFnMap[item.index].fn()"></div>

              <span>
                本报告样本，项目执⾏⼈共计21⼈。完成1-60单的1⼈，占⽐4.76%，
                有效百分⽐为4.76%
              </span>
            </div>

            <component
              class="subTitleCmpt"
              v-if="subTitleCmpt"
              :is="subTitleCmpt"
              v-bind="{
                innerText: '项目背景'
              }"
            />

            <div
              :style="{
                fontSize: '14px',
                position: 'relative',
                height: '120px',
                padding: '28px 24px 18px 32px'
              }"
            >
              <div v-html="getBorderFnMap[item.index].fn()"></div>

              <span>
                本报告样本，项目执⾏⼈共计21⼈。完成1-60单的1⼈，占⽐4.76%，
                有效百分⽐为4.76%
              </span>
            </div>

            <component :is="cmpName(item.value)" />

            <component
              style="width: 60px; height: 30px"
              v-if="pageNoCmpt"
              :is="pageNoCmpt"
            />
          </div>
        </div>
        <div class="bi-tmpl-detail__right__cmpt__radioBox">
          <BaseRadio
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            {{}}
          </BaseRadio>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleBackground from '../bi-pc-module/pc-module-background/index';
import { getBorderFnMap } from '../bi-pc-module/pc-module-border/index';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const TYPE_MAPPING = [1, 2, 3, 4, 5].map(i => {
  return {
    value: 'pc-module-background-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleBackground.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, titleCmpt, pageNoCmpt, subTitleCmpt } =
  useDetailCmpt();
</script>
<style lang="scss" scope></style>
